export default __webpack_public_path__ + "static/media/title-block.080ffc15.gif";